<template>
  <div class="p-2">
    <p class="lead text-center">{{ eventData.device.name }}</p>
    <table class="table">
      <tr>
        <th>{{ $t('dmp.event_id') }}</th>
        <td>{{ eventData.alarm.event_id }}</td>
      </tr>
      <tr>
        <th>{{ $t('dmp.event') }}</th>
        <td>{{ eventData.alarm.description }}</td>
      </tr>
      <tr>
        <th>{{ $t('dmp.eventDefinition') }}</th>
        <td>{{ eventData.alarm.event_definition }}</td>
      </tr>
      <tr>
        <th>{{ $t('dmp.eventType') }}</th>
        <td>{{ eventData.alarm.event_type }}</td>
      </tr>
      <tr>
        <th>{{ $t('dmp.deviceName') }}</th>
        <td>{{ eventData.alarm.device_id }} {{ eventData.alarm.device_name }}</td>
      </tr>
      <tr>
        <th>{{ $t('dmp.deviceType') }}</th>
        <td>
          <span class="text-uppercase">{{ eventData.alarm.device_type }}</span>
        </td>
      </tr>
      <template v-if="eventData.alarm.device_alias">
        <tr>
          <th>{{ $t('dmp.name') }}</th>
          <td>{{ eventData.alarm.device_alias }}</td>
        </tr>
      </template>
      <tr>
        <th>{{ $t('dmp.panel_model') }}</th>
        <td>{{ eventData.device.model }}</td>
      </tr>
      <tr>
        <th>{{ $t('dmp.date') }}</th>
        <td>{{ formattedDate }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "dmp-event-data",
  props: {
    eventData: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {}
  },
  computed: {
    formattedDate() {

      return moment
        .tz(this.eventData.alarm.event_created_at, 'UTC')
        .local()
        .format("YYYY-MM-DD HH:mm");
    }
  }
}
</script>


<style scoped lang="scss">

</style>
